import React, { useState } from "react";
import { Table, Badge } from "antd";
import { Card, CardBody } from "reactstrap";

// import data from "./TablesData.json";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { in_fact, add_facts_id } from "../../Redux/actions";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { uid } from "uid";
import dayjs from "dayjs";
import { gql, useLazyQuery, useQuery } from "@apollo/client";

const GET_PLANT_EVENTS = gql`
  query events($plant_id: Int!, $dates: [Date], $offset_date: Int, $skip: Int) {
    GetSystemsEvents(
      plant_id: $plant_id
      dates: $dates
      skip: $skip
      offset_date: $offset_date
    ) {
      gateway_Event {
        event_time
        event_code
        description
        Event_Description {
          title
          content
        }
        plant_id
        Gateway_id
        Gateway_Devices {
          serial_number
        }
      }
      po_Event {
        event_time
        event_code
        description
        Event_Description {
          title
          content
        }
        plant_id
        PO_id
        Power_Optimizer {
          serial_number
        }
      }
      gateway_count
      po_count
    }
  }
`;

const TablesClean = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [evenstData, setEventsData] = useState([]);
  const [eventsCount, setEventsCount] = useState([]);
  const [getEvents, { loading }] = useLazyQuery(GET_PLANT_EVENTS, {
    onCompleted: (res) => {
      console.log(res.GetSystemsEvents);
      const { gateway_Event, po_Event, gateway_count, po_count } =
        res.GetSystemsEvents;
      const combineEvents = [...gateway_Event, ...po_Event];
      combineEvents.sort((a, b) => b.event_time - a.event_time);
      setEventsCount(gateway_count + po_count);
      setEventsData(combineEvents.slice(0, 5));
    },

    // onError: (err) => {
    //   console.log(err);
    // },
  });
  // const data = (props.data)
  const dispatch = useDispatch();
  const checkStatusColor = (status) => {
    switch (status) {
      case "stable":
        return "green";
      case "unstable":
        return "red";
      case "unknown":
        return "orange";
      default:
        return "blue";
    }
  };
  const checkStatusText = (status) => {
    switch (status) {
      case "stable":
        return lang_choiced.pages.choice_fact.table.status_text.stable;
      case "unstable":
        return lang_choiced.pages.choice_fact.table.status_text.unstable;
      case "unknown":
        return lang_choiced.pages.choice_fact.table.status_text.unknown;
      default:
        return lang_choiced.pages.choice_fact.table.status_text.default;
    }
  };
  // Child Table Start
  const expandedRowRender = (record) => {
    const columns = [
      {
        title: lang_choiced.pages.choice_fact.table.nestedTable.index,
        dataIndex: "row",
        render: (text, record, index) => index + 1,
      },
      {
        title: lang_choiced.pages.choice_fact.table.nestedTable.event_time,
        dataIndex: "event_time",
        width: "20%",
        render: (item) => {
          return dayjs(item, { jalali: true }).format("YYYY/MM/DD HH:mm:ss");
        },
        className: "ltr",
      },
      {
        title: lang_choiced.pages.choice_fact.table.nestedTable.event_code,
        dataIndex: "event_code",
      },
      {
        title: lang_choiced.pages.choice_fact.table.nestedTable.event_title,
        dataIndex: "Event_Description",

        width: "20%",
        render: (item) => item.title,
      },
      {
        title: lang_choiced.pages.choice_fact.table.nestedTable.event_description,
        dataIndex: "",
        width: "45%",
        render: (item) =>
          `${item.Event_Description.content} ${
            item.description ? `(${item.description})` : ""
          }`,
      },
    ];
    return (
      <Table
        rowKey={(record) => uid()}
        pagination={{ hideOnSinglePage:true }}
        columns={columns}
        dataSource={evenstData}
        scroll={{ x: 1000 }}
        loading={loading}
      />
    );
  };
  //   Child Table End

  const columns = [
    {
      title: lang_choiced.pages.choice_fact.table.fact_name,
      dataIndex: "",
      key: "fact_name",
      width: "30%",
      style:{textAlign:"left"},
      render: (item) => {
        return (
          <span
            key={item.plant_id}
            className=""
            onClick={() => {
              dispatch(in_fact(true));
            }}
          >
            <Link
              to={{
                pathname: `/${item.plant_id}/dashboard`,

                state: {
                  unicID: item.plant_id,
                },
              }}
              className="none-link fact-list-title"
            >
              {item.fact_name}
            </Link>
          </span>
        );
      },
    },
    {
      title: lang_choiced.pages.choice_fact.table.fact_address,
      dataIndex: "fact_address",
      key: "fact_address",
      width: "30%",
    },
    {
      title: lang_choiced.pages.choice_fact.table.prod_index,
      dataIndex: "prod_index",
      key: "prod_index",
      width: "20%",
      render: (item) => {
        const color = checkStatusColor(item);
        const text = checkStatusText(item);
        return <Badge color={color} text={` ${text} `} />;
      },
    },
    {
      title: lang_choiced.pages.choice_fact.table.fact_index,
      dataIndex: "fact_index",
      key: "fact_index",
      width: "20%",
      render: (item) => {
        const color = checkStatusColor(item);
        const text = checkStatusText(item);
        return <Badge color={color} text={` ${text} `} />;
      },
    },
    // Extra Action :
    // { title: "Action", key: "operation", render: () => <a>Publish</a> },
  ];
  const data = props.setdata;
  // console.log(data, "is data");
  // const dataSource = data
  let all_fact_id = [];
  useEffect(() => {
    // console.log(data, "is api table");

    data.map((item) => {
      all_fact_id.push(item.plant_id);
    });

    // console.log(all_fact_id, "is all fact id");
    dispatch(add_facts_id(all_fact_id));
  }, []);

  return (
    <div className="animated fadeIn">
      <Card>
        <CardBody>
          <Table
            pagination={{ pageSize: 5 }}
            className="components-table-demo-nested"
            columns={columns}
            expandable={{
              expandedRowRender,
              onExpand: (isOpen, record) => {
                console.log(isOpen, record.plant_id, "is event");
                if (isOpen) {
                  const today = new Date();
                  getEvents({
                    variables: {
                      plant_id: record.plant_id,
                      dates: [today, today],
                      offset_date: today.getTimezoneOffset(),
                      skip: 0,
                    },
                  });
                }
              },
            }}
            dataSource={data}
            scroll={{ x: 1000 }}
            rowKey={(record) => record.plant_id}
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default TablesClean;
